<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-p-3 ts-flex ts-space-x-3">
    <div class="ts-w-full">
      <label>{{ $t('saleContract.saleType') }}</label>
      <a-select
        v-model.number="model.sale_type_id"
        class="ts-w-full"
        :options="saleContractTypeList"
      ></a-select>
      <div class="validate" v-if="errors.has('sale_type_id')">
        {{ errors.first('sale_type_id') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'saleContractType',
  props: ['value', 'validate'],
  data () {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['formViewData']),
    saleContractTypeList () {
      if (!this.formViewData.saleContractType) return []
      return this.formViewData.saleContractType.map(el => ({
        value: el.sale_type_id,
        label: el.sale_type
      }))
    }
  }
}
</script>
